<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="C6100-serien">
     C6100-serien
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_no" title="Sikkerhetsinformasjon">
     Sikkerhetsinformasjon
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Konvensjoner">
      Konvensjoner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_no" title="Bli kjent med skriveren">
     Bli kjent med skriveren
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_no" title="Finne informasjon om skriveren">
      Finne informasjon om skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_no" title="Velge en plassering for skriveren">
      Velge en plassering for skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_no" title="Skriverkonfigurasjoner">
      Skriverkonfigurasjoner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_no" title="Koble til kabler">
      Koble til kabler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_no" title="Ved hjelp av kontrollpanelet">
      Ved hjelp av kontrollpanelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_no" title="L&aelig;re om status for av/p&aring;-knappen og indikatorlampen">
      L&aelig;re om status for av/p&aring;-knappen og indikatorlampen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_no" title="Bruke startsiden">
      Bruke startsiden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_no" title="Menyoversikt">
      Menyoversikt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_no" title="Skrive ut en menyinnstillingsside">
      Skrive ut en menyinnstillingsside
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_no" title="Papir som ikke kan brukes">
      Papir som ikke kan brukes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_no" title="Bruke resirkulert papir">
      Bruke resirkulert papir
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_no" title="Konfigurere og bruke programmer p&aring; startbildet">
     Konfigurere og bruke programmer p&aring; startbildet
    </a>
   </p>
   <div id="divd0e1162">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_no" title="Tilpasse startsiden">
      Tilpasse startsiden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_no" title="Bruke Skjermtilpasning.">
      Bruke Skjermtilpasning.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_no" title="Konfigurere Skjemaer og favoritter">
      Konfigurere Skjemaer og favoritter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_no" title="Konfigurere milj&oslash;innstillinger">
      Konfigurere milj&oslash;innstillinger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_no" title="Bruke programmet Brukerst&oslash;tte">
      Bruke programmet Brukerst&oslash;tte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_no" title="Bruke en QR-kodegenerator">
      Bruke en QR-kodegenerator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_no" title="Konfigurere enhetskvoter">
      Konfigurere enhetskvoter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_no" title="Bruke Google Disk">
      Bruke Google Disk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1390" title="Administrere kontakter">
      Administrere kontakter
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_no" title="Konfigurering og bruk av tilgjengelighetsfunksjonene">
     Konfigurering og bruk av tilgjengelighetsfunksjonene
    </a>
   </p>
   <div id="divd0e1509">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_no" title="Aktivere forst&oslash;rrelsesmodus">
      Aktivere forst&oslash;rrelsesmodus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_no" title="Aktivere taleveiledning">
      Aktivere taleveiledning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_no" title="Justere talehastighet for taleveiledningen">
      Justere talehastighet for taleveiledningen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_no" title="Aktivere oppleste passord eller PIN-koder">
      Aktivere oppleste passord eller PIN-koder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_no" title="Navigere p&aring; skjermen ved hjelp av bevegelser">
      Navigere p&aring; skjermen ved hjelp av bevegelser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_no" title="Bruke tastaturet p&aring; skjermen">
      Bruke tastaturet p&aring; skjermen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_no" title="Legge i papir og spesialpapir">
     Legge i papir og spesialpapir
    </a>
   </p>
   <div id="divd0e1712">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_no" title="Angi st&oslash;rrelse og type spesialpapir">
      Angi st&oslash;rrelse og type spesialpapir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_no" title="Konfigurere innstillinger for universalpapir">
      Konfigurere innstillinger for universalpapir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_no" title="Legge i skuffer">
      Legge i skuffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_no" title="Legge papir i flerbruksmateren">
      Legge papir i flerbruksmateren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_no" title="Koble sammen skuffer">
      Koble sammen skuffer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_no" title="utskrift">
     utskrift
    </a>
   </p>
   <div id="divd0e1898">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_no" title="Skrive ut fra en datamaskin">
      Skrive ut fra en datamaskin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_no" title="Skrive ut skjemaer">
      Skrive ut skjemaer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1949" title="Skrive ut fra en mobilenhet">
      Skrive ut fra en mobilenhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_no" title="Skrive ut fra en flash-stasjon">
      Skrive ut fra en flash-stasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_no" title="St&oslash;ttede flash-stasjoner og filtyper">
      St&oslash;ttede flash-stasjoner og filtyper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_no" title="Konfigurere konfidensielle jobber">
      Konfigurere konfidensielle jobber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_no" title="Skrive ut holdte jobber">
      Skrive ut holdte jobber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_no" title="Skrive ut en liste med skrifteksempler">
      Skrive ut en liste med skrifteksempler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_no" title="Avbryte en utskriftsjobb">
      Avbryte en utskriftsjobb
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_no" title="Sikre skriveren">
     Sikre skriveren
    </a>
   </p>
   <div id="divd0e2339">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_no" title="Finne sikkerhetssporet">
      Finne sikkerhetssporet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_no" title="Slette skriverminne">
      Slette skriverminne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_no" title="Slette innholdet p&aring; skriverens harddisk">
      Slette innholdet p&aring; skriverens harddisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_no" title="Konfigurere kryptering av skriverens harddisk">
      Konfigurere kryptering av skriverens harddisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_no" title="Gjenopprette fabrikkinnstillingene">
      Gjenopprette fabrikkinnstillingene
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_no" title="Erkl&aelig;ring om flyktig og ikke-flyktig minne">
      Erkl&aelig;ring om flyktig og ikke-flyktig minne
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_no" title="Vedlikeholde skriveren">
     Vedlikeholde skriveren
    </a>
   </p>
   <div id="divd0e2549">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2554" title="Justere h&oslash;yttalervolumet">
      Justere h&oslash;yttalervolumet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2646" title="Nettverksutskrift">
      Nettverksutskrift
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_no" title="Konfigurere seriell utskrift (bare Windows)">
      Konfigurere seriell utskrift (bare Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_no" title="Rengj&oslash;re skriveren">
      Rengj&oslash;re skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_no" title="Bestille deler og rekvisita">
      Bestille deler og rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3212" title="Bytte ut deler og rekvisita">
      Bytte ut deler og rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_no" title="Oppbevare rekvisita">
      Oppbevare rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3682" title="Flytte skriveren">
      Flytte skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3738" title="Slik sparer du str&oslash;m og papir">
      Slik sparer du str&oslash;m og papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3876" title="Gjenvinning">
      Gjenvinning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_no" title="Fjerne fastkj&oslash;rt papir">
     Fjerne fastkj&oslash;rt papir
    </a>
   </p>
   <div id="divd0e3930">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_no" title="Unng&aring; papirstopp">
      Unng&aring; papirstopp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_no" title="Identifisere hvor papiret har kj&oslash;rt seg fast">
      Identifisere hvor papiret har kj&oslash;rt seg fast
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_no" title="Papirstopp i skuffer">
      Papirstopp i skuffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_no" title="Papirstopp i flerbruksmateren">
      Papirstopp i flerbruksmateren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_no" title="Papirstopp i standardskuffen">
      Papirstopp i standardskuffen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_no" title="Papirstopp i deksel&nbsp;B">
      Papirstopp i deksel&nbsp;B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_no" title="Papirstopp i utskuffen for ferdiggj&oslash;ring">
      Papirstopp i utskuffen for ferdiggj&oslash;ring
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_no" title="Stiftestopp i deksel&nbsp;G">
      Stiftestopp i deksel&nbsp;G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_no" title="Feils&oslash;king">
     Feils&oslash;king
    </a>
   </p>
   <div id="divd0e4274">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4277" title="Problemer med nettverkstilkoblingen">
      Problemer med nettverkstilkoblingen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4492" title="Problemer med maskinvarealternativer">
      Problemer med maskinvarealternativer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4764" title="Problemer med rekvisita">
      Problemer med rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_no" title="Problemer med papirmating">
      Problemer med papirmating
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_no" title="Utskriftsproblemer">
      Utskriftsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7306" title="Problemer med fargekvaliteten">
      Problemer med fargekvaliteten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_no" title="Hvordan du kan kontakte brukerst&oslash;tte">
      Hvordan du kan kontakte brukerst&oslash;tte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_no" title="Oppgradering og flytting">
     Oppgradering og flytting
    </a>
   </p>
   <div id="divd0e7541">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7544" title="Maskinvare">
      Maskinvare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7870" title="Programvare">
      Programvare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7946" title="Fastvare">
      Fastvare
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug.html#laser_ug_notices_no" title="Merknader">
     Merknader
    </a>
   </p>
   <div id="divd0e8015">
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e8018" title="Produktinformasjon">
      Produktinformasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e8035" title="Utgivelsesmerknad">
      Utgivelsesmerknad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#trademarks_no" title="Varemerker">
      Varemerker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#licensing-notices_no" title="Lisensmerknader">
      Lisensmerknader
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#noise-emission-levels_no" title="St&oslash;yniv&aring;er">
      St&oslash;yniv&aring;er
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e8123" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e8150" title="Oppladbart litiumionbatteri">
      Oppladbart litiumionbatteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#eu-battery-directive-2023-1542_no" title="Forskrift (EU) 2023/1542">
      Forskrift (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#returning-lexmark-cartridges-for-reuse-or-recycling_no" title="Returnere Lexmark-kassetter for gjenbruk eller gjenvinning">
      Returnere Lexmark-kassetter for gjenbruk eller gjenvinning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#static-sensitivity-notice_no" title="Varsel om statisk elektrisitet">
      Varsel om statisk elektrisitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#temperature-information_no" title="Temperaturinformasjon">
      Temperaturinformasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#laser-notice_no" title="Lasermerknad">
      Lasermerknad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#laser-advisory-label_no" title="Laserveiledningsetikett">
      Laserveiledningsetikett
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue